import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';

import { ModalType } from '@connect-services/client/components/abstract-modal/abstract-modal.component';
import { ConfirmationModal } from '@connect-services/client/components/confirmation-modal/confirmation-modal.component';
import { ModalResultEnum } from '@connect-services/client/models/common.model';

@Injectable({
    providedIn: 'root',
})
export class EditModeLeaveModalService {
    private readonly dialog = inject(MatDialog);
    private readonly translocoService = inject(TranslocoService);

    public openLeaveEditModeDialog(pendingEditCount: number): Promise<boolean> {
        const description = this.translocoService.translate('unsavedEditsWillBeLost');

        const dialogRef = this.dialog.open(ConfirmationModal, {
            autoFocus: false,
            data: {
                cancelLabel: this.translocoService.translate('cancel'),
                confirmLabel: this.translocoService.translate('quit'),
                description: pendingEditCount ? `${description} (${pendingEditCount})` : description,
                title: this.translocoService.translate('editMode.areYouSureToLeave'),
                type: ModalType.DANGER,
            },
            disableClose: true,
            restoreFocus: false,
            width: '36rem',
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe((result: ModalResultEnum) => {
                resolve(result === ModalResultEnum.CONFIRM);
            });
        });
    }

    public openLeaveEntityEditionDialog(): Promise<boolean> {
        const dialogRef = this.dialog.open(ConfirmationModal, {
            autoFocus: false,
            data: {
                cancelLabel: this.translocoService.translate('cancel'),
                confirmLabel: this.translocoService.translate('confirm'),
                description: this.translocoService.translate('editMode.leaveEntityEditionWithoutSaving'),
                title: this.translocoService.translate('warning'),
                type: ModalType.DANGER,
            },
            disableClose: true,
            restoreFocus: false,
            width: '36rem',
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe((result: ModalResultEnum) => {
                resolve(result === ModalResultEnum.CONFIRM);
            });
        });
    }
}
